var FilterBar = Backbone.View.extend({
    tagName: 'div',
    className: 'filter-bar',
    events: {
        'change input.filter-check' : 'updateFilters'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'buildFilters', 'updateFilters', 'filterItems' );

        if ( typeof this.template === 'undefined' ) {
            this.template = _.template( '<%= name %>' );
        }
        // this.listenTo( this.model, 'buildFilters', this.buildFilters );
    },
    render: function(){
        // nothing here, once the filters are populated it will generate those inputs
    },
    buildFilters: function(){
        var filters = this.model.get( 'filters' );
        var props = Object.keys( filters );
        for ( var i = 0; i < props.length; i++ ) {
            var prop = props[i];
            var templateDetails = {
                name: prop,
                terms: filters[prop]
            };

            var filterGroup = this.template( templateDetails );
            this.$el.append( filterGroup );
        }
    },
    updateFilters: function(){
        var selection = {};
        this.$( 'input:checked' ).each( function(){
            var p = this.dataset.prop;
            if ( typeof selection[p] === 'undefined' ) {
                selection[p] = [];
            }
            selection[p].push( this.value );
        });

        this.filter = selection;
        this.filterItems();
    },
    filterItems: function(){
        var filter_keys = Object.keys( this.filter );

        var i, y, selected_filter;
        for( var f=0; f < this.collection.length; f++) {
            let item = this.collection.at( f );
            // foreach product
            let visiblity = true;
            let settings = item.toJSON();

            for ( i = 0; i < filter_keys.length; i++ ) {
                y = filter_keys[i];
                selected_filter = this.filter[y];
                // if a selection is not made for the selected filter, it shouldn't be used in processing the visibility of this item.
                if ( _.isNull( selected_filter ) ) {
                    continue;
                }
                // check to see if the property and the selection overlap some how.
                if ( _.isArray( selected_filter ) && selected_filter.includes( settings[y] ) ) {
                    continue;
                } if ( _.isArray( settings[y] ) && _.isArray( selected_filter ) && _.intersection( selected_filter, settings[y] ) ) {
                    continue;
                } else if ( selected_filter === true && settings[y] !== selected_filter ) {
                    visiblity = false;
                } else if ( settings[y] !== selected_filter ) {
                    visiblity = false;
                }

                // once we know it is false, then we can bail out
                if ( ! visiblity ) {
                    break;
                }
            }

            // set visible on item model
            item.set( {'visible' : visiblity } );
        }
    }
});

export {FilterBar};